import { useCallback } from 'react'

import type { Membership } from '@space-shell/common/services/membership/types'
import { useMembershipStore } from '@space-shell/core/store'

const useMembership = () => {
  const { membershipSlug, membershipData, setMembershipSlug, setMembershipData } =
    useMembershipStore()

  const saveLastSlug = useCallback(
    (membershipSlug: string) => setMembershipSlug(membershipSlug),
    [setMembershipSlug]
  )

  const saveMembershipData = useCallback(
    (data: Membership) => setMembershipData(data),
    [setMembershipData]
  )

  const resetMembershipData = useCallback(
    () => setMembershipData({} as Membership),
    [setMembershipData]
  )

  return { membershipSlug, membershipData, saveLastSlug, saveMembershipData, resetMembershipData }
}

export default useMembership
